import { Expandable } from '@warp-ds/react';
import { trackBenefitDropdownExpand } from '@/utils/tracking';

type Props = {
    title: string;
    items: React.ReactNode[];
    type?: 'qasa' | 'finn';
    itemId?: string | null;
};

const COLORS = {
    qasa: '#F9F9F6',
    finn: '#F0F0F2',
};

export const BenefitExpandable = ({ title, items, type = 'qasa', itemId = null }: Props) => (
    <div className="mb-8">
        <Expandable
            style={{ backgroundColor: COLORS[type] }}
            title={<p className="mb-0 font-bold text-14">{title}</p>}
            box
            onChange={(expanded) => {
                if (expanded) {
                    trackBenefitDropdownExpand(type, itemId, title);
                }
            }}>
            <div className="flex-col gap-16">
                {items.map((item, index) => (
                    <div
                        key={`${
                            // biome-ignore lint/suspicious/noArrayIndexKey: use index
                            index
                        }`}
                        className="flex items-center gap-8 mb-4">
                        <div className="text-caption">{item}</div>
                    </div>
                ))}
            </div>
        </Expandable>
    </div>
);
